import React, {ImgHTMLAttributes} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {PreloadableImage} from '../PreloadableImage/PreloadableImage';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const ImageBubble: React.FC<Props> = ({className, ...props}) => (
  <RoundedContainer className={className}>
    <BubbleImg height="100%" width="100%" {...props} />
  </RoundedContainer>
);

const RoundedContainer = styled.div`
  background-color: ${COLORS.Grey4};
  height: 100%;
  width: 100%;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  z-index: 0;
`;

const BubbleImg = styled(PreloadableImage)`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-position: 50% 0;
`;
